var collection = document.querySelectorAll('.collection-list__item')
var container = document.querySelector('.collection-list')

collection.forEach(function(card) {
    card.addEventListener("mouseover", function() {
        collection.forEach(function(card) {
            if (card.classList.contains("active")) {
                card.classList.remove("active");
            }
        })
        card.classList.add('active')
    })
    container.addEventListener("mouseleave", function() {
        collection.forEach(function(card) {
                card.classList.remove("active");
                collection[0].classList.add("active");
        })
        
    })
})

